import React from 'react';
import DisplayBanner from '../Organism/DisplayBanner'

const Banners: React.FC = () => {
   return (
    <DisplayBanner />       
  );
};

export default Banners;